export default function PageHeader({ icon: Icon, title, count, children }) {
  return (
    <div className="flex items-center justify-between mb-4 flex-shrink-0">
      <div className="flex items-center gap-2">
        {Icon && <Icon size={20} className="text-brand flex-shrink-0" />}
        <h1 className="text-xl font-bold text-white">{title}</h1>
        {count != null && <span className="text-gray-600 text-sm">({count})</span>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
